import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { FilePond } from 'react-filepond'
import 'filepond/dist/filepond.min.css'

FilePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  initialFiles: PropTypes.array,
  acceptedFileTypes: PropTypes.array,
  maxFiles: PropTypes.number,
  allowReorder: PropTypes.bool,
  maxFileSize: PropTypes.string,
  labels: PropTypes.object,
}

export default function FilePicker({
  onChange,
  initialFiles = [],
  acceptedFileTypes = ['application/pdf'],
  maxFiles = 50,
  allowReorder = false,
  maxFileSize = '100MB',
  labels = {},
}) {
  const { t } = useTranslation()

  const defaultLabels = {
    labelIdle:
      labels.labelIdle ||
      t(
        'components.file-picker.dropzone-text',
        'Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
      ),
    labelFileLoadError:
      labels.labelFileLoadError ||
      t('components.file-picker.file-load-error', 'Error during load'),
    labelFileProcessing:
      labels.labelFileProcessing ||
      t('components.file-picker.file-processing', 'Uploading'),
    labelFileProcessingComplete:
      labels.labelFileProcessingComplete ||
      t('components.file-picker.file-processing-complete', 'Upload complete'),
    labelFileProcessingAborted:
      labels.labelFileProcessingAborted ||
      t('components.file-picker.file-processing-aborted', 'Upload cancelled'),
    labelFileProcessingError:
      labels.labelFileProcessingError ||
      t('components.file-picker.file-processing-error', 'Error during upload'),
    labelTapToRetry:
      labels.labelTapToRetry ||
      t('components.file-picker.tap-to-retry', 'Tap to retry'),
    labelTapToCancel:
      labels.labelTapToCancel ||
      t('components.file-picker.tap-to-cancel', 'Tap to cancel'),
    labelFileTypeNotAllowed:
      labels.labelFileTypeNotAllowed ||
      t('components.file-picker.file-type-not-allowed', 'File of invalid type'),
    fileValidateTypeLabelExpectedTypes:
      labels.fileValidateTypeLabelExpectedTypes ||
      t(
        'components.file-picker.file-validate-type-expected-types',
        'Expects {allTypes}'
      ),
    labelMaxFileSizeExceeded:
      labels.labelMaxFileSizeExceeded ||
      t('components.file-picker.max-file-size-exceeded', 'File is too large'),
    labelMaxFileSize:
      labels.labelMaxFileSize ||
      t(
        'components.file-picker.max-file-size',
        'Maximum file size is {filesize}'
      ),
  }

  return (
    <FilePond
      files={initialFiles}
      onupdatefiles={(fileItems) => {
        onChange(fileItems.map((fileItem) => fileItem.file))
      }}
      onreorderfiles={(fileItems) => {
        if (allowReorder) {
          onChange(fileItems.map((fileItem) => fileItem.file))
        }
      }}
      allowMultiple
      maxFiles={maxFiles}
      allowReorder={allowReorder}
      acceptedFileTypes={acceptedFileTypes}
      maxFileSize={maxFileSize}
      {...defaultLabels}
    />
  )
}
